import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// В dev-режиме на iOS/Safari CRA собирает бандл через eval, и браузер маскирует
// ЛЮБУЮ ошибку как безликое «Script error.» без файла/строки. Толку от неё ноль,
// а dev-оверлей она перекрывает весь экран. Гасим именно этот кросс-ориджин шум
// (в capture-фазе, до обработчика react-error-overlay). Реальные ошибки с текстом
// и стеком не трогаем, и в проде этого кода нет.
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (e) => {
    if (e && e.message === 'Script error.' && !e.filename && !e.lineno) {
      e.stopImmediatePropagation();
    }
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);